

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadFeedNotifications
// GETUNREADFEEDNOTIFICATIONS   

const GETUNREADFEEDNOTIFICATIONS= createAsyncThunk(
  "getUnreadFeedNotifications/getUnreadFeedNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadFeedNotificationsSlice = createSlice({
  name: "getUnreadFeedNotificationsSlice",
  initialState: {
    getUnreadFeedNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadFeedNotifications: (state) => {
        state.getUnreadFeedNotifications.loading = false
        state.getUnreadFeedNotifications.error = false
        state.getUnreadFeedNotifications.data = []
        state.getUnreadFeedNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADFEEDNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadFeedNotifications = {
        ...state.getUnreadFeedNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADFEEDNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadFeedNotifications = {
        ...state.getUnreadFeedNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADFEEDNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadFeedNotifications = {
        ...state.getUnreadFeedNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadFeedNotificationsAction = {
    GETUNREADFEEDNOTIFICATIONS,
};

export { getUnreadFeedNotificationsAction };
export default getUnreadFeedNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadFeedNotifications} = getUnreadFeedNotificationsSlice.actions